import { Component, Inject, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { PageResult } from 'app/shared/interfaces/page-result';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { CepService } from 'app/shared/services/cep.service';
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { VendedorPopupComponent } from '../vendedor-popup/vendedor-popup.component';
import { CadastroVendedor } from 'app/shared/interfaces/cadastro-vendedor';

@Component({
  selector: 'app-cadastro-vendedor-popup',
  templateUrl: './cadastro-vendedor-popup.component.html',
  styleUrls: ['./cadastro-vendedor-popup.component.scss']
})
export class CadastroVendedorPopupComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginatorVendedor: MatPaginator;
  
  layoutConf: any;
  pageObjectVendedor$: BehaviorSubject<PageResult<CadastroVendedor>> = new BehaviorSubject<PageResult<CadastroVendedor>>(null);
  cadastroVendedores: CadastroVendedor[];
  pageVendedor = 1;
  lengthVendedor = 0;
  pageSizeVendedor = 5;
  pageEventVendedor = null;
  pageSizeOptionsVendedor: number[] = [5, 10, 25];
  cadastro: Cadastro;
  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';
  dialogRefVendedor: MatDialogRef<any>;




  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CadastroVendedorPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private authService: JwtAuthService,
    private loader: AppLoaderService,
    private cadastroService: CadastroService,
    private cepService: CepService,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.cadastro = this.data.payload;


    this.pageObjectVendedor$.subscribe(
      page => {
        if (page != null) {
          this.cadastroVendedores = page.content;
          this.lengthVendedor = page.totalElements;
          this.pageSizeVendedor = page.size;
          this.pageVendedor = page.number;
          if (this.pageVendedor === 1) {
            this.paginatorVendedor.firstPage();
          }
        } else {
          this.cadastroVendedores = [];
        }
      });

      this.getPageVendedor(this.pageVendedor, this.pageSizeVendedor, this.cadastro.id);  
  }

  getPageVendedor(page: number, pageSize: number, id: number) {
    if (id !== undefined) {
      this.cadastroService.getPageVendedor(page, pageSize, this.selectedOrdem, this.selectedDirect, id.toString()).subscribe(val => { this.pageObjectVendedor$.next(val) })
    }
  }

  reloadPageVendedor() {
    this.pageVendedor = 1;
    this.getPageVendedor(this.pageVendedor, this.pageSizeVendedor, this.cadastro.id);
  }

  deleteVendedor(data: any = {}, isNew?) {
    this.confirmService.confirm({ message: `Deletar vendedor/representante ${(data?.vendedor?.codigo ?? '').toString().padStart(6, '0')} - ${data?.vendedor?.razaoSocial ?? ''}?` })
      .subscribe(res => {
        if (res) {
          this.loader.open();
          this.cadastroService.deleteCadastroVendedor(data.id)
            .subscribe({
              next: data2 => {
                this.loader.close();
                this.confirmService.confirm({
                  title: data2.status ? 'Sucesso' : 'Erro', message: data2.status
                    ? `Vendedor/representante removido com sucesso!`
                    : `Erro ao deletar vendedor/representante (há dependências), tente desativar o cadastro!`, error: false
                });
                if (data2.status) {
                  this.getPageVendedor(1, this.pageSizeVendedor, this.cadastro.id);
                }
              },
              error: (error: HttpErrorResponse) => {
                this.loader.close();
                const message = error?.status === 404
                  ? 'Vendedor/representante não encontrado para exclusão.'
                  : 'Erro ao deletar vendedor/representante.';
                this.confirmService.confirm({ title: 'Erro', message, error: true });
              }
            })
        }
      })
  }

  popUpVendedor(data: any = {}, isNew?) {
    const title = isNew ? 'Novo Vendedor/Representante' : 'Alterar Vendedor/Representante';
    if (isNew) {
      data = { cadastro: this.cadastro };
    }
    this.dialogRefVendedor = this.dialog.open(VendedorPopupComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title, payload: data }
    })
    
    this.dialogRefVendedor.afterClosed().subscribe(res => this.reloadPageVendedor());

    // this.dialogRef.afterClosed()
    //   .subscribe(res => {

    //     console.log(`FECHANDO >>> ${JSON.stringify(res)}`);
        
    //     if (!res) {
    //       return;
    //     }
    //     if (this.instanceOfA(res)) {
    //       this.loader.open();
    //       this.cadastroService.saveOrUpdateVendedor(res)
    //         .subscribe(data2 => {
    //           this.loader.close();
    //           this.snack.open('Endereço Salvo com sucesso!', 'OK', { duration: 5500 });
    //           this.reloadPageVendedor();
    //         }, (err: HttpErrorResponse) => {
    //           this.loader.close(); 
    //           this.snack.open('Erro ao savar o endereço!', 'ERRO', { duration: 5500 });
    //         })
    //     } else {
    //       this.confirmService.confirm({
    //         title: 'Município informado incorretamente, verifique!', error: true
    //       });
    //     }
    //   })
  }

  

  setPageSizeOptionsVendedor(event: PageEvent) {
    this.pageSizeVendedor = event.pageSize;
    this.getPageVendedor(event.pageIndex + 1, event.pageSize, this.cadastro.id);
  }

 

  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
            this.dialogRef.close();
        }
      });
  }


}
